<template>
  <van-nav-bar
    :title="title"
    left-arrow
    @click-left="onClickLeft"
  >
    <!-- 自定义右侧内容 -->
    <template v-if="showRight">
      <van-icon
        name="search"
        size="18"
      />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    title: {
      type: String,
      required: true,
    }
  },
  methods: {
    onClickLeft () {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
/* 样式 */
</style>
